module.exports = __webpack_public_path__ + "static/media/folder.21f49d57.svg";